import { useEffect, useState } from "react";
import EachProductSold from "./EachProductSold";
import { returnAllProductUrl, supplyAllProductUrl, clearLoanUrl, extendLoanUrl, splitPaymentUrl, pushPaymentKudaUrl } from "../api/endpoints";
import { useSelector, useDispatch } from "react-redux";
import { MdRemoveRedEye } from "react-icons/md";
import { registerReminderForLoan } from "../screens/stores/makeTansaction/ConfirmSelection";
import {
  clearLoanData,
  extendLoanDuration,
  returnAllProductsInTodayTransaction,
  splitLoanPayment,
  supplyAllProductsInTodayTransaction,
} from "../tools/indexdb";
import { addToQueue } from "../slice/offlineQueue";
import { BsPrinterFill } from "react-icons/bs";
import InvoicePDF from "../screens/stores/makeTansaction/printTest/GeneratePDF";
import { ArrowUpCircle, Truck, Undo2 } from "lucide-react";
import { uiAlert } from "./alerts/customAlert/uiAlert";
import ClearLoanModal from "./transactionDetailAction/CLearLoan";
import RegisterPaymentModal from "./transactionDetailAction/SplitPayment";
import ExtendLoanModal from "./transactionDetailAction/ExtendDueDates";

const TransactionDetails = ({
  selectedTrans,
  updateSelectedTrans,
  updateClearedLoan,
  setAlertDisplay,
  updatePreviousLoan,
  fetchTodayTransactionFromIBD,
  fetchTodayTransaction,
  currency,
  socket,
  displayedTimeline, // false if not today transaction
  todayTrans,
  setTodaysTransaction,
  setAllGoodsOnLoan,
}) => {
  const [openClearLoanModal, setOpenClearLoanModal] = useState(false);
  const [openExtendLoanModal, setOpenExtendLoanModal] = useState(false);
  const [openSplitPaymentModal, setOpenSplitPaymentModal] = useState(false);
  const [newExtendDate, setNewExtendDate] = useState("");
  const [isExtendDateValid, setIsExtendDateValid] = useState(false);
  const [splitPaymentAmount, setSplitPaymentAmount] = useState(null);
  const [loanPaymentMode, setLoanPaymentMode] = useState("cash"); // ["cash", "card", "mobilePay"]
  const [isSplitPaymentAmountValid, setIsSplitPaymentAmountValid] = useState(false);
  const [openMobileTransactionDetail, setOpenMobileTransactionDetail] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const { store } = useSelector((state) => state.store);
  const dispatch = useDispatch();
  const { employee } = useSelector((state) => state.employee);

  useEffect(() => {
    setNewExtendDate("");
  }, [openExtendLoanModal]);

  useEffect(() => {
    if (new Date(selectedTrans.operationType.dateToPay) < new Date(newExtendDate)) {
      setIsExtendDateValid(true);
      console.log("Valid date");
    } else {
      setIsExtendDateValid(false);
      console.log("Invalid date");
    }
  }, [newExtendDate]);

  useEffect(() => {
    if (splitPaymentAmount > 0 && splitPaymentAmount <= selectedTrans.operationType.balance) {
      setIsSplitPaymentAmountValid(true);
    } else {
      setIsSplitPaymentAmountValid(false);
    }
  }, [splitPaymentAmount]);

  const returnAllProduct = async () => {
    if (employee && !employee.allowedActions.canProcessReturns) {
      uiAlert("You don't have permission to process returns. Contact your boss", "error");
      return;
    }

    let payload = {
      transactionID: selectedTrans.transID,
      productIDs: selectedTrans.products.map((product) => product.id),
      customer: selectedTrans.customer.fullName,
      employee, //full employee object
    };
    let accessToken = localStorage.getItem("accessToken");

    if (window.confirm("Are you sure you want to return all items?\nAll items will be added back to your stock)")) {
      if (selectedTrans.isPreviousLoan) {
        try {
          let response = await fetch(returnAllProductUrl + store._id, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          });

          if (response.ok) {
            console.log("All items returned");
            let { transaction, modifiedProducts_R, updatedStoreProductCollection, store } = await response.json();

            setAlertDisplay({
              showAlert: true,
              type: "success",
              title: "Items returned",
              message: "All items have been returned to your stock",
            });

            updateSelectedTrans({ ...transaction, isPreviousLoan: true });
            //   fetchTodayTransaction();
            // fetchTodayTransactionFromIBD();
            setTodaysTransaction((prev) => {
              //replace the transaction with the updated one

              let index;
              let foundTrans = prev.find((tran, i) => {
                if (tran.transID === transaction.transID) {
                  index = i;
                  return true;
                }
              });
              if (foundTrans) {
                let newArr = [...prev];
                newArr[index] = { ...transaction, isPreviousLoan: true };
                return newArr;
              } else {
                return prev;
              }
            });

            setAllGoodsOnLoan((prev) => {
              let index;
              let foundTrans = prev.find((tran, i) => {
                if (tran.transID === transaction.transID) {
                  index = i;
                  return true;
                }
              });
              if (foundTrans) {
                let newArr = [...prev];
                newArr[index] = transaction;
                return newArr;
              } else {
                return prev;
              }
            });
          }
        } catch (error) {
          console.log(error);
          setAlertDisplay({
            showAlert: true,
            type: "error",
            title: "Return failed",
            message: "Failed to return items. Please try again.",
          });
        }
      } else {
        try {
          if (displayedTimeline) {
            let { transactionList, modifiedTransaction } = await returnAllProductsInTodayTransaction(store.storeName, selectedTrans.transID);
            console.log(transactionList, modifiedTransaction);
            updateSelectedTrans(modifiedTransaction);
            setAlertDisplay({
              showAlert: true,
              type: "success",
              title: "Items returned",
              message: "All items have been returned to your stock",
            });
            fetchTodayTransactionFromIBD();

            let offlineQueueItem = {
              fetchPayload: payload,
              fetchUrl: returnAllProductUrl + store._id,
              fetchMethod: "PUT",
              fetchAccessToken: accessToken,
              storeID: store._id,
              queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
            };
            dispatch(addToQueue(offlineQueueItem));
          } else {
            console.log("New fetching today transaction, not previous loan");
            let response = await fetch(returnAllProductUrl + store._id, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify(payload),
            });

            if (response.ok) {
              console.log("All items returned");
              let { transaction, modifiedProducts_R, updatedStoreProductCollection, store } = await response.json();

              setAlertDisplay({
                showAlert: true,
                type: "success",
                title: "Items returned",
                message: "All items have been returned to your stock",
              });

              updateSelectedTrans(transaction);
              //   fetchTodayTransaction();
              fetchTodayTransactionFromIBD();
            }
          }

          /*   
        } */
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const supplyAllItem = async () => {
    if (window.confirm("Are you sure you want to supply all items?\nThis can not be undone)")) {
      try {
        if (displayedTimeline) {
          let { transactionList, modifiedTransaction } = await supplyAllProductsInTodayTransaction(store.storeName, selectedTrans.transID);

          updateSelectedTrans(modifiedTransaction);
          fetchTodayTransactionFromIBD();
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Items supplied",
            message: "All items have been supplied to the customer",
          });

          let offlineQueueItem = {
            fetchPayload: { transactionID: selectedTrans.transID, employee },
            fetchUrl: supplyAllProductUrl + store._id,
            fetchMethod: "PUT",
            fetchAccessToken: localStorage.getItem("accessToken"),
            storeID: store._id,
            queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
          };
          dispatch(addToQueue(offlineQueueItem));
        } else {
          let payload = { transactionID: selectedTrans.transID, employee }; // full employee object
          let response = await fetch(supplyAllProductUrl + store._id, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(payload),
          });
          if (response.ok) {
            let { transaction } = await response.json();

            updateSelectedTrans(transaction);
            //  fetchTodayTransaction();
            fetchTodayTransactionFromIBD();
            setAlertDisplay({
              showAlert: true,
              type: "success",
              title: "Items supplied",
              message: "All items have been supplied to the customer",
            });
          }
        }

        /*    */
      } catch (error) {
        console.log(error);
      }
    }
  };

  const clearLoan = async (payments, paymentMode, amount) => {
    if (selectedTrans.transactionDetails.deliveryStatus === "returned") return uiAlert("This loan has been returned. No need to clear the loan.", "info");
    let payload = {
      transactionID: selectedTrans.transID,
      totalClearedAmount: selectedTrans.operationType.balance,
      paymentMode: loanPaymentMode,
      paymentMode,
      payments,
      amount,
      employee,
    };

    if (selectedTrans.transactionDetails.deliveryStatus === "returned") return uiAlert("This loan has been returned. No need to clear the loan.", "info");

    if (selectedTrans.isPreviousLoan) {
      try {
        let response = await fetch(clearLoanUrl + store._id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          let { transaction, clearedLoanToday } = await response.json();
          console.log(transaction, clearedLoanToday);
          registerReminderForLoan(transaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Loan cleared",
            message: "Loan has been cleared. And cleared amount has been updated",
          });

          updateSelectedTrans({ ...transaction, isPreviousLoan: true });
          updateClearedLoan(clearedLoanToday);
          setOpenClearLoanModal(false);

          updatePreviousLoan({ ...transaction, isPreviousLoan: true });

          setTodaysTransaction((prev) => {
            //replace the transaction with the updated one

            let index;
            let foundTrans = prev.find((tran, i) => {
              if (tran.transID === transaction.transID) {
                index = i;
                return true;
              }
            });
            if (foundTrans) {
              console.log("fetching today transaction, previous loan", transaction);

              let newArr = [...prev];
              newArr[index] = { ...transaction, isPreviousLoan: true };
              return newArr;
            } else {
              console.log("fetching today transaction, not previous loan", transaction);

              return prev;
            }
          });
          return;
        }
        throw new Error("Failed to clear loan");
      } catch (error) {
        console.log(error);
        return uiAlert("Failed to clear loan. Please try again.", "error");
      }
    } else {
      try {
        if (displayedTimeline) {
          let { modifiedTransaction, clearedLoanToday } = await clearLoanData(
            store.storeName,
            selectedTrans.transID,
            selectedTrans.operationType.balance,
            paymentMode,
            payments,
            amount,
          );
          console.log(modifiedTransaction, clearedLoanToday);
          registerReminderForLoan(modifiedTransaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Loan cleared",
            message: "Loan has been cleared. And cleared amount has been updated",
          });

          updateSelectedTrans(modifiedTransaction);
          updateClearedLoan(clearedLoanToday);
          setOpenClearLoanModal(false);

          console.log(selectedTrans.isPreviousLoan);

          console.log("fetching today transaction, not previous loan");

          fetchTodayTransactionFromIBD();

          let offlineQueueItem = {
            fetchPayload: payload,
            fetchUrl: clearLoanUrl + store._id,
            fetchMethod: "PUT",
            fetchAccessToken: localStorage.getItem("accessToken"),
            storeID: store._id,
            queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
          };
          dispatch(addToQueue(offlineQueueItem));
        } else {
          let response = await fetch(clearLoanUrl + store._id, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(payload),
          });
          if (response.ok) {
            let { transaction, clearedLoanToday } = await response.json();
            console.log(transaction, clearedLoanToday);
            registerReminderForLoan(transaction, socket, store);
            setAlertDisplay({
              showAlert: true,
              type: "success",
              title: "Loan cleared",
              message: "Loan has been cleared. And cleared amount has been updated",
            });

            updateSelectedTrans(transaction);
            updateClearedLoan(clearedLoanToday);
            setOpenClearLoanModal(false);
            fetchTodayTransactionFromIBD();
          }
        }

        /*   */
      } catch (error) {
        console.log(error);
      }
    }
  };

  const splitPaymentFun = async (splitPaymentAmount, loanPaymentMode, payment) => {
    if (selectedTrans.transactionDetails.deliveryStatus === "returned") return uiAlert("This loan has been returned. No need to split the payment.", "info");

    setIsSplitPaymentAmountValid(false);
    let payload = {
      transactionID: selectedTrans.transID,
      amountCleared: splitPaymentAmount,
      paymentMode: loanPaymentMode,
      payments: payment,
      amount: splitPaymentAmount,
      employee,
    };

    if (selectedTrans.isPreviousLoan) {
      try {
        let response = await fetch(splitPaymentUrl + store._id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          let { transaction, clearedLoanToday } = await response.json();
          registerReminderForLoan(transaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Payment registered",
            message: "Payment has been registered. And cleared amount has been updated",
          });
          updateSelectedTrans({ ...transaction, isPreviousLoan: true });
          updateClearedLoan(clearedLoanToday);
          setOpenSplitPaymentModal(false);

          updatePreviousLoan({ ...transaction, isPreviousLoan: true });
          setTodaysTransaction((prev) => {
            //replace the transaction with the updated one

            let index;
            let foundTrans = prev.find((tran, i) => {
              if (tran.transID === transaction.transID) {
                index = i;
                return true;
              }
            });
            if (foundTrans) {
              console.log("fetching today transaction, previous loan", transaction);

              let newArr = [...prev];
              newArr[index] = { ...transaction, isPreviousLoan: true };
              return newArr;
            } else {
              console.log("fetching today transaction, not previous loan", transaction);

              return prev;
            }
          });
          return;
        }
      } catch (error) {
        console.log(error);
        return uiAlert("Failed to register payment. Please try again.", "error");
      }
    } else {
      console.log("this loan is not previous loan");

      try {
        if (displayedTimeline) {
          /* means its from todays transaction */
          let { transactionList, modifiedTransaction, clearedLoanToday } = await splitLoanPayment(
            store.storeName,
            selectedTrans.transID,
            splitPaymentAmount,
            loanPaymentMode,
            payment,
            splitPaymentAmount, //does nothing
          );

          registerReminderForLoan(modifiedTransaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Payment registered",
            message: "Payment has been registered. And cleared amount has been updated",
          });

          updateSelectedTrans(modifiedTransaction);
          updateClearedLoan(clearedLoanToday);
          setOpenSplitPaymentModal(false);

          fetchTodayTransactionFromIBD();
          let offlineQueueItem = {
            fetchPayload: payload,
            fetchUrl: splitPaymentUrl + store._id,
            fetchMethod: "PUT",
            fetchAccessToken: localStorage.getItem("accessToken"),
            storeID: store._id,
            queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
          };
          dispatch(addToQueue(offlineQueueItem));
        } else {
          /* loan from queried days */
          let response = await fetch(splitPaymentUrl + store._id, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(payload),
          });
          if (response.ok) {
            let { transaction, clearedLoanToday } = await response.json();
            registerReminderForLoan(transaction, socket, store);
            setAlertDisplay({
              showAlert: true,
              type: "success",
              title: "Payment registered",
              message: "Payment has been registered. And cleared amount has been updated",
            });
            updateSelectedTrans(transaction);
            updateClearedLoan(clearedLoanToday);
            setOpenSplitPaymentModal(false);
            fetchTodayTransactionFromIBD();

            // updatePreviousLoan(transaction);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const extendLoanFun = async () => {
    if (selectedTrans.transactionDetails.deliveryStatus === "returned") return uiAlert("This loan has been returned. No need to extend the due date.", "info");
    setIsExtendDateValid(false);
    let payload = { transactionID: selectedTrans.transID, newDate: newExtendDate, employee };

    if (selectedTrans.isPreviousLoan) {
      try {
        let response = await fetch(extendLoanUrl + store._id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          let { transaction } = await response.json();
          console.log(transaction);
          registerReminderForLoan(transaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Loan extended",
            message: "Loan due date has been extended to " + newExtendDate + "",
          });

          updateSelectedTrans({ ...transaction, isPreviousLoan: true });
          setOpenExtendLoanModal(false);
          updatePreviousLoan({ ...transaction, isPreviousLoan: true });

          setTodaysTransaction((prev) => {
            //replace the transaction with the updated one

            let index;
            let foundTrans = prev.find((tran, i) => {
              if (tran.transID === transaction.transID) {
                index = i;
                return true;
              }
            });
            if (foundTrans) {
              console.log("fetching today transaction, previous loan", transaction);

              let newArr = [...prev];
              newArr[index] = { ...transaction, isPreviousLoan: true };
              return newArr;
            } else {
              console.log("fetching today transaction, not previous loan", transaction);

              return prev;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      if (displayedTimeline) {
        try {
          let { transactionList, modifiedTransaction } = await extendLoanDuration(store.storeName, selectedTrans.transID, newExtendDate);
          console.log(transactionList, modifiedTransaction);
          registerReminderForLoan(modifiedTransaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Loan extended",
            message: "Loan due date has been extended to " + newExtendDate + "",
          });

          updateSelectedTrans(modifiedTransaction);
          setOpenExtendLoanModal(false);
          fetchTodayTransactionFromIBD();

          let offlineQueueItem = {
            fetchPayload: payload,
            fetchUrl: extendLoanUrl + store._id,
            fetchMethod: "PUT",
            fetchAccessToken: localStorage.getItem("accessToken"),
            storeID: store._id,
            queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
          };
          dispatch(addToQueue(offlineQueueItem));
        } catch (error) {
          console.log(error);
          throw new Error(error, "IDB error");
        }
      } else {
        let response = await fetch(extendLoanUrl + store._id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          let { transaction } = await response.json();

          registerReminderForLoan(transaction, socket, store);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Loan extended",
            message: "Loan due date has been extended to " + newExtendDate + "",
          });

          fetchTodayTransactionFromIBD();

          updateSelectedTrans(transaction);
          setOpenExtendLoanModal(false);
          // updatePreviousLoan(transaction);
        }
      }
    }

    /*    */
  };

  const handlePrintReceipt = () => {
    setShowReceipt(true);
    setTimeout(() => {
      setShowReceipt(false);
    }, 5000);
  };

  const pushToTerminal = async ({ accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID }) => {
    // try to push to KUDA terminal

    console.log(accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID);

    const url = `${pushPaymentKudaUrl}${store._id}/`;

    try {
      let response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID: transID || selectedTrans.transID }),
      });

      /* uiAlert(`Successfully pushed ${amount} to ${accountName} via ${provider}`, "success"); */

      /*    return { success: true, message: "Transaction successful" }; */
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        return {
          success: false,
          message: data?.message || "Failed to push to terminal",
          data,
        };
      }

      return {
        success: true,
        message: data?.message || (response.ok ? "Transaction successful" : "Failed to push to terminal"),
        data,
      };
    } catch (error) {
      console.error("Error pushing to terminal:", error);
      return {
        success: false,
        message: error.message || "Failed to push to terminal",
        error,
      };
    }
  };

  return (
    <>
      <div onClick={() => updateSelectedTrans(null)} className='tranactionDetail'>
        <div onClick={(e) => e.stopPropagation()} className='transactionListItemsWrapper'>
          <div className='transDetailHeader'>
            <div className='rtjdy63b'>
              <p>Details</p>{" "}
              <p>
                ({selectedTrans.products.length} {selectedTrans.products.length === 1 ? "item sold" : "items sold"})
              </p>
            </div>
            <div className='rtjdy63b'>
              {selectedTrans.operationType?.whichOperation === "loan" && selectedTrans.transactionDetails.deliveryStatus !== "returned" && (
                <button className='printTrasDet74' style={{ backgroundColor: "rgb(221, 40, 40)", color: "white" }} onClick={returnAllProduct}>
                  <Undo2 />
                </button>
              )}
              <button onClick={handlePrintReceipt} className='printTrasDet74'>
                <BsPrinterFill />
              </button>
              <button className='printTrasDet74' onClick={() => updateSelectedTrans(null)}>
                X
              </button>
            </div>
          </div>
          <div className='TDetailDivmon6453'>
            <div className='TdetailBtnDivs'>
              {/* <div>
                <button>Return All items</button>
                <button>Return All items</button>
                <button>Print</button>
              </div> */}
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <div className='returnItemOrSupButtonDiv'>
                  {selectedTrans.operationType.whichOperation === "loan" ? (
                    selectedTrans.operationType?.balance === 0 ? (
                      <button style={{ opacity: "0.5", cursor: "not-allowed" }}> Clear loan </button>
                    ) : (
                      <div>
                        <button className='clearloanBTN' onClick={() => setOpenClearLoanModal(true)}>
                          {" "}
                          Clear loan{" "}
                        </button>
                        <button onClick={() => setOpenSplitPaymentModal(true)}> Part payment</button>
                      </div>
                    )
                  ) : selectedTrans.transactionDetails.deliveryStatus === "returned" ? (
                    <button style={{ opacity: "0.5", cursor: "not-allowed" }}> Return All item</button>
                  ) : (
                    <button style={{ backgroundColor: "rgb(221, 40, 40)" }} onClick={returnAllProduct}>
                      {" "}
                      Return All item
                    </button>
                  )}
                  {selectedTrans.operationType?.whichOperation === "loan" ? (
                    selectedTrans.operationType?.balance === 0 ? (
                      <button style={{ opacity: "0.5", cursor: "not-allowed" }}>Extend due date</button>
                    ) : (
                      <button onClick={() => setOpenExtendLoanModal(true)}>Extend due date</button>
                    )
                  ) : selectedTrans.transactionDetails.deliveryStatus === "notSupplied" ? (
                    <button onClick={supplyAllItem}> Supply All item</button>
                  ) : (
                    <button style={{ opacity: "0.5", cursor: "not-allowed" }}> Supply All item</button>
                  )}
                  {selectedTrans.operationType?.whichOperation === "loan" && selectedTrans.transactionDetails.deliveryStatus === "notSupplied" && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "40px",
                        width: "50px",
                        borderRadius: "10px",
                        border: "1px solid rgb(105, 178, 237)",
                        color: "rgb(27, 139, 230)",
                        cursor: "pointer",
                      }}
                      onClick={supplyAllItem}
                    >
                      <Truck />
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className='productListWra9864'>
              {selectedTrans.products.map((product, i) => {
                return (
                  <EachProductSold
                    key={i}
                    product={product}
                    whichOperation={selectedTrans.operationType.whichOperation}
                    transId={selectedTrans.transID}
                    updateSelectedTrans={updateSelectedTrans}
                    customer={selectedTrans.customer.fullName}
                    setAlertDisplay={setAlertDisplay}
                    fetchTodayTransactionFromIBD={fetchTodayTransactionFromIBD}
                    fetchTodayTransaction={fetchTodayTransaction}
                    queriedTrans={false}
                    currency={currency}
                    todayTrans={todayTrans}
                    displayedTimeline={displayedTimeline}
                    isPreviousLoan={selectedTrans.isPreviousLoan}
                  />
                );
              })}
            </div>
            <div className='detailsCusDi37463'>
              <p className='dTit463'>Customer Information</p>
              <div className='custcont37uD'>
                <div className='EacDet35jdh'>
                  <span>Name</span>
                  <span>{selectedTrans.customer.fullName ? selectedTrans.customer.fullName : "no"}</span>
                </div>
                <div className='EacDet35jdh'>
                  <span>Email</span>
                  <span>{selectedTrans.customer.email ? selectedTrans.customer.email : "no"}</span>
                </div>
                <div className='EacDet35jdh'>
                  <span>Phone number</span>
                  <span>{selectedTrans.customer.phoneNumber ? selectedTrans.customer.phoneNumber : "no"}</span>
                </div>
                <div style={{ border: "none" }} className='EacDet35jdh'>
                  <span>Address</span>
                  <span>{selectedTrans.customer.address ? selectedTrans.customer.address : "no"}</span>
                </div>
              </div>
            </div>
            <div className='detailsCusDi37463'>
              <p className='dTit463'>Transaction details</p>
              <div className='custcont37uD'>
                <div className='EacDet35jdh'>
                  <span>Date</span>
                  <span>{new Date(selectedTrans.transactionDetails.date)?.toLocaleDateString("en-CA")}</span>
                </div>
                <div className='EacDet35jdh'>
                  <span>Delivery Status</span>
                  {/*     <span>
                    <div className={`Tstatus  `}>
                      <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                      <span> Supplied</span>
                    </div>
                  </span> */}

                  {/* test */}
                  {selectedTrans?.transactionDetails.deliveryStatus === "supplied" ? (
                    <>
                      <div className={`Tstatus  `}>
                        <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                        <span> Supplied</span>
                      </div>
                    </>
                  ) : selectedTrans?.transactionDetails.deliveryStatus === "returned" ? (
                    <div style={{ backgroundColor: "rgb(236, 236, 236)" }} className={`Tstatus  `}>
                      <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                      <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
                    </div>
                  ) : (
                    <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                      <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                      <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
                    </div>
                  )}

                  {/* test end */}
                </div>
                <div className='EacDet35jdh'>
                  <span>Sold by</span>
                  <span>{selectedTrans.soldBy.fullName ? selectedTrans.soldBy.fullName : "Admin"}</span>
                </div>
                <div className='EacDet35jdh'>
                  <span>Payment mode</span>
                  <span>{selectedTrans.transactionDetails.paymentMode}</span>
                </div>
                <div className='EacDet35jdh'>
                  <span>Sub total</span>
                  <span>
                    {selectedTrans.transactionDetails.subTotal
                      ? selectedTrans.transactionDetails.subTotal?.toLocaleString()
                      : selectedTrans.transactionDetails.totalAmount?.toLocaleString()}
                  </span>
                </div>

                {selectedTrans.transactionDetails.deliveryFee ? (
                  <div className='EacDet35jdh'>
                    <span>DeliveryFee</span>
                    <span>
                      {currency}
                      {parseInt(selectedTrans.transactionDetails.deliveryFee || 0)?.toLocaleString()}{" "}
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {selectedTrans.transactionDetails.serviceCharge ? (
                  <div className='EacDet35jdh'>
                    <span>Service charge</span>
                    <span>
                      {currency}
                      {parseInt(selectedTrans.transactionDetails.serviceCharge || 0)?.toLocaleString()}{" "}
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {selectedTrans.transactionDetails.extraPayment ? (
                  <div className='EacDet35jdh'>
                    <span>Extra payment (Off record debt)</span>
                    <span>
                      {currency}
                      {parseInt(selectedTrans.transactionDetails.extraPayment || 0)?.toLocaleString()}{" "}
                    </span>
                  </div>
                ) : (
                  ""
                )}

                <div className='EacDet35jdh'>
                  <span>Discount</span>
                  <span>
                    {" "}
                    -{currency}
                    {parseInt(selectedTrans.transactionDetails.discount || 0)?.toLocaleString()}{" "}
                  </span>
                </div>
                <div className='EacDet35jdh'>
                  <span>
                    {" "}
                    VAT({Number(selectedTrans.transactionDetails.vatPercentage?.toString()) || selectedTrans.transactionDetails.vatPercentage?.$numberDecimal}
                    %){" "}
                  </span>
                  <span>
                    {" "}
                    {currency}
                    {Number(selectedTrans.transactionDetails.vat || 0)?.toLocaleString()}{" "}
                  </span>
                </div>

                {Number(selectedTrans.transactionDetails.clearedbalance || 0) > 0 && (
                  <div className='EacDet35jdh'>
                    <span>Amount from old balance</span>
                    <span>
                      {" "}
                      {currency}
                      {Number(selectedTrans.transactionDetails.clearedbalance || 0)?.toLocaleString()}{" "}
                    </span>
                  </div>
                )}

                {selectedTrans.operationType.whichOperation === "loan" && (
                  <>
                    <div className='EacDet35jdh'>
                      <span>Inital Pay</span>
                      <span>
                        {currency}
                        {selectedTrans.operationType.intialPayment?.toLocaleString()}{" "}
                      </span>
                    </div>
                    {selectedTrans.operationType.clearedAmount && selectedTrans.operationType.whichOperation === "loan" ? (
                      <div className='EacDet35jdh'>
                        <span>Cleared amount </span>
                        <span>
                          {currency}
                          {selectedTrans.operationType.clearedAmount?.toLocaleString()}
                        </span>
                      </div>
                    ) : null}
                    <div className='EacDet35jdh'>
                      <span>Balance </span>
                      <span>
                        {currency}
                        {selectedTrans.operationType.balance?.toLocaleString()}{" "}
                      </span>
                    </div>
                  </>
                )}
                {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.balance !== 0 && (
                  <>
                    <div className='EacDet35jdh'>
                      <span style={{ color: "rgb(226, 22, 22)" }}>Due date </span>
                      <span style={{ color: "rgb(226, 22, 22)" }}>{selectedTrans.operationType.dateToPay}</span>
                    </div>
                  </>
                )}
                {selectedTrans.operationType.balance === 0 && (
                  <>
                    <div className='EacDet35jdh'>
                      <span>Amount Cleared</span>
                      <span>{selectedTrans.operationType.clearedAmount?.toLocaleString()}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Date Cleared</span>
                      <span>{selectedTrans.operationType.clearedDate}</span>
                    </div>
                  </>
                )}

                <div style={{ border: "none" }} className='EacDet35jdh'>
                  <span>Total price</span>
                  <span>
                    {" "}
                    {currency}
                    {selectedTrans.transactionDetails.subTotal
                      ? selectedTrans.transactionDetails.totalAmount?.toLocaleString()
                      : (
                          parseInt(selectedTrans.transactionDetails.totalAmount) - Number(selectedTrans.transactionDetails.discount || 0)
                        )?.toLocaleString()}{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openClearLoanModal && (
        <ClearLoanModal
          isOpen={openClearLoanModal}
          amount={selectedTrans.operationType?.balance}
          onCancel={() => {
            setOpenClearLoanModal(false);
          }}
          onConfirm={async ({ amount, paymentMode, payments }) => {
            await clearLoan(payments, paymentMode, amount);
          }}
          loanPaymentMode={loanPaymentMode}
          setLoanPaymentMode={setLoanPaymentMode}
          currency={currency}
          pushToTerminal={async (entry) => {
            return await pushToTerminal(entry);
          }}
          socket={socket}
        />
      )}

      {openExtendLoanModal && (
        <ExtendLoanModal
          isOpen={openExtendLoanModal}
          dueDate={selectedTrans.operationType.dateToPay}
          onCancel={() => {
            setOpenExtendLoanModal(false);
          }}
          onConfirm={async () => {
            await extendLoanFun();
          }}
          newExtendDate={newExtendDate}
          setNewExtendDate={setNewExtendDate}
        />
      )}
      {openSplitPaymentModal && (
        <RegisterPaymentModal
          isOpen={openSplitPaymentModal}
          balance={selectedTrans.operationType?.balance}
          onCancel={() => {
            setOpenSplitPaymentModal(false);
          }}
          onConfirm={async ({ splitPaymentAmount, loanPaymentMode, payment }) => {
            await splitPaymentFun(splitPaymentAmount, loanPaymentMode, payment);
          }}
          splitPaymentAmount={splitPaymentAmount}
          setSplitPaymentAmount={setSplitPaymentAmount}
          loanPaymentMode={loanPaymentMode}
          setLoanPaymentMode={setLoanPaymentMode}
          currency={currency}
          pushToTerminal={async (entry) => {
            return await pushToTerminal(entry);
          }}
          socket={socket}
          transID={selectedTrans.transID}
        />
      )}
      {showReceipt && <InvoicePDF invoiceData={selectedTrans} />}
    </>
  );
};

export default TransactionDetails;

const MobileTransactionDetail = ({ selectedTrans, currency, setOpenMobileTransactionDetail }) => {
  return (
    <>
      <div className='responivWrapper'>
        <div>
          <div style={{ display: "flex" }} className='TransactionInfo'>
            <h5 style={{ fontSize: "0.93rem" }} className='TransactionInfoh5Title'>
              Customer Information
            </h5>
            <div style={{ fontSize: "0.83rem", width: "100%", gap: "60px" }} className='TransactionInfoinline'>
              <div>
                <p>Name: </p>
                <p>Email: </p>
                <p>Phone no: </p>
                <p>Address: </p>
              </div>
              <div>
                <p>{selectedTrans.customer.fullName ? selectedTrans.customer.fullName : "no"}</p>
                <p>{selectedTrans.customer.email}</p>
                <p>{selectedTrans.customer.phoneNumber}</p>
                <p>{selectedTrans.customer.address}</p>
              </div>
            </div>
            <h5 style={{ fontSize: "0.93rem" }} className='TransactionInfoh5Title'>
              Transaction details
            </h5>
            <div style={{ fontSize: "0.83rem", width: "100%" }} className='TransactionInfoinline'>
              <div>
                <p>Date: </p>
                {/* <p>Transaction ID: </p> */}
                <p>Delivery status: </p>
                <p>Payment mode: </p>
                <p>Number of items: </p>
                <p>Total price </p>
                {selectedTrans.operationType.whichOperation === "loan" && <p>Inital Pay: </p>}
                {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.clearedAmount && (
                  <p style={{ color: "green" }}>Cleared amount: </p>
                )}
                {selectedTrans.operationType.whichOperation === "loan" && <p>Balance: </p>}
                {selectedTrans.operationType.balance !== 0 && selectedTrans.operationType.whichOperation === "loan" && (
                  <p style={{ color: "red" }}>Due date: </p>
                )}
                {selectedTrans.operationType.balance === 0 && <p style={{ color: "green" }}>Amount Cleared:</p>}
                {selectedTrans.operationType.balance === 0 && <p style={{ color: "green" }}>Date Cleared:</p>}
              </div>
              <div>
                <p>{selectedTrans.transactionDetails.date.split("T")[0]}</p>
                {/* <p>{selectedTrans._id}</p> */}
                <p>{selectedTrans.transactionDetails.deliveryStatus}</p>
                <p>{selectedTrans.transactionDetails.paymentMode}</p>
                <p>{selectedTrans.transactionDetails.numberOfItems}</p>
                <p>
                  {currency}
                  {selectedTrans.transactionDetails.totalAmount}
                </p>
                {selectedTrans.operationType.whichOperation === "loan" && (
                  <p>
                    {currency}
                    {selectedTrans.operationType.intialPayment}{" "}
                  </p>
                )}
                {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.clearedAmount && (
                  <p style={{ color: "green" }}>{selectedTrans.operationType.clearedAmount} </p>
                )}
                {selectedTrans.operationType.whichOperation === "loan" && (
                  <p>
                    {currency}
                    {selectedTrans.operationType.balance}{" "}
                  </p>
                )}
                {selectedTrans.operationType.balance !== 0 && selectedTrans.operationType.whichOperation === "loan" && (
                  <p style={{ color: "red" }}>{selectedTrans.operationType.dateToPay}</p>
                )}
                {selectedTrans.operationType.balance === 0 && <p style={{ color: "green" }}>{selectedTrans.operationType.clearedAmount}:</p>}
                {selectedTrans.operationType.balance === 0 && <p style={{ color: "green" }}>{selectedTrans.operationType.clearedDate}:</p>}
              </div>
            </div>
          </div>
        </div>

        <button onClick={() => setOpenMobileTransactionDetail(false)}>Close detail</button>
      </div>
    </>
  );
};
